const __DEFAULT_PAGE_SIZE__ = 10;
export async function listingRequest(endpoint, options) {
    const params = new URLSearchParams();
    options.facetsToShow?.forEach((facet) => params.append('FacetsToShow', facet));
    options.filters?.forEach((filter) => params.append(filter.filterKey, filter.key));
    options.startingLetter && params.append('StartingLetter', options.startingLetter);
    options.byBrand && params.append('ByBrand', options.byBrand.toString());
    if (typeof options.page === 'number') {
        const pageSize = options.pageSize || __DEFAULT_PAGE_SIZE__;
        params.append('From', (options.page * pageSize).toString());
        params.append('PageSize', pageSize.toString());
    }
    else if (typeof options.pageSize === 'number') {
        params.append('PageSize', options.pageSize.toString());
    }
    if (!!options.parentPage) {
        params.append('ParentPage', String(options.parentPage));
    }
    if (options.sort) {
        params.append('Sort', options.sort);
    }
    // Construct the full URL with all parameters
    const url = `${endpoint}?${params}`;
    const response = await fetch(url);
    return response.json();
}
